import { VestingResponse } from "@/modules/user/types/vesting";
import { apiWithAuth } from "../authApi";

export const getVesting = async (): Promise<VestingResponse | undefined> => {
  try {
    const response = await apiWithAuth.get("/user/deposit/reward/vesting");

    const answer = response.data as VestingResponse;

    return answer;
  } catch (error) {
    return undefined;
  }
};
